import React from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
// External libs
import { get } from 'lodash';
// Components
import CustomSwitch from '../common/custom-switch';
// Styles
import useStyles from './AutomaticCookingTimeSetting.style';

const AutomaticCookingTimeSetting = props => {
  const {
    title,
    description,
    classes = {},
    isActive = false,
    onChangeSwitch = () => undefined,
  } = props;

  const componentClasses = useStyles();

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <div
        className={classNames(
          componentClasses.textContainer,
          classes.textContainer,
        )}
      >
        <div className={classNames(componentClasses.title, classes.title)}>
          {title}
        </div>
        <div
          className={classNames(
            componentClasses.description,
            classes.description,
          )}
        >
          {description}
        </div>
      </div>
      <CustomSwitch
        classes={{ root: componentClasses.switchRoot }}
        checked={isActive}
        onChange={async e => {
          await onChangeSwitch(get(e, 'target.checked', false));
        }}
      />
    </div>
  );
};

export default injectIntl(AutomaticCookingTimeSetting);
